import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "bottom" }
const _hoisted_3 = { class: "order-amount" }
const _hoisted_4 = { class: "order-amount-info" }
const _hoisted_5 = { class: "total-amount-text" }
const _hoisted_6 = { class: "order-actual-amount" }

import { onMounted, ref } from 'vue';
  import router from '@/router';
  import { useRoute } from 'vue-router';
  import { getOrder } from '@/service/order';
  import { OrderDetailModel } from '@/model/order';
  import { insertInvoice, getInvoiceList } from '@/service/invoice';
  import h5Config from '@/config/config';
  import { showDialog, showSuccessToast } from 'vant';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'InvoiceView',
  setup(__props) {

_useCssVars(_ctx => ({
  "22033f50": (_unref(h5Config).themeColor)
}))

  const route = useRoute();
  const orderId = ref(0);
  const orderModel = ref<OrderDetailModel>({});
  const title = ref('');
  const taxNo = ref('');
  const bankName = ref('');
  const bankAccount = ref('');
  const companyAddress = ref('');
  const companyPhone = ref('');
  const invoiceType = ref(1);
  const content = ref(1);
  const emailAddress = ref('');

  onMounted(async () => {
    orderId.value = Number(route.params.id || 0);
    loadOrder();
  });

  const loadOrder = async () => {
    const orderResp = await getOrder({ orderId: orderId.value });
    orderModel.value = orderResp.result || {};

    if (!orderModel.value.orderNo) {
      return;
    }
    const invoiceListResp = await getInvoiceList({
      pageNum: 1,
      pageSize: 1,
      data: {
        orderNo: orderModel.value.orderNo,
        invoiceStatus: 10,
      },
    });
    const invoiceList = invoiceListResp?.result?.list || [];
    if (!invoiceList.length) return;

    const invoiceItem = invoiceList[0];
    const invoiceUrl = invoiceItem.invoiceUrl || '';
    if (invoiceUrl) {
      window.location.replace(invoiceUrl);
    }
  };

  const onClickLeft = () => {
    router.back();
  };

  const submitInvoice = async () => {
    console.log(
      title.value,
      taxNo.value,
      bankName.value,
      bankAccount.value,
      companyAddress.value,
      companyPhone.value,
      invoiceType.value,
      content.value,
      emailAddress.value,
    );

    const res = await insertInvoice({
      shopId: orderModel.value.shopId,
      invoiceType: invoiceType.value,
      title: title.value,
      taxNo: taxNo.value,
      bankName: bankName.value,
      bankAccount: bankAccount.value,
      companyAddress: companyAddress.value,
      companyPhone: companyPhone.value,
      content: content.value === 1 ? '商品明细' : '商品类别',
      orderCount: 1,
      orderNos: [orderModel.value.orderNo],
      invoiceAmount: orderModel.value.totalAmount,
      receiveType: 1,
      emailAddress: emailAddress.value,
    });
    if (res.code === 200) {
      showSuccessToast({ message: '提交成功' });
      loadOrder();
    } else {
      showDialog({ message: res.msg || '开票失败' });
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "开具发票",
      border: "",
      fixed: "",
      "left-arrow": "",
      onClickLeft: onClickLeft
    }, {
      left: _withCtx(() => [
        _createVNode(_component_van_icon, {
          name: "arrow-left",
          size: "22",
          color: "#000"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_field, {
      name: "invoiceType",
      label: "发票类型"
    }, {
      input: _withCtx(() => [
        _createVNode(_component_van_tag, {
          plain: "",
          size: "medium",
          color: invoiceType.value === 1 ? _unref(h5Config).themeColor : '',
          "text-color": invoiceType.value === 1 ? _unref(h5Config).themeColor : '',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (invoiceType.value = 1))
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode(" 个人 ")
          ])),
          _: 1,
          __: [11]
        }, 8, ["color", "text-color"]),
        _cache[13] || (_cache[13] = _createTextVNode("    ")),
        _createVNode(_component_van_tag, {
          plain: "",
          size: "medium",
          color: invoiceType.value === 2 ? _unref(h5Config).themeColor : '',
          "text-color": invoiceType.value === 2 ? _unref(h5Config).themeColor : '',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (invoiceType.value = 2))
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode(" 单位 ")
          ])),
          _: 1,
          __: [12]
        }, 8, ["color", "text-color"])
      ]),
      _: 1
    }),
    _createVNode(_component_van_field, {
      name: "content",
      label: "内容"
    }, {
      input: _withCtx(() => [
        _createVNode(_component_van_tag, {
          plain: "",
          size: "medium",
          color: content.value === 1 ? _unref(h5Config).themeColor : '',
          "text-color": content.value === 1 ? _unref(h5Config).themeColor : '',
          onClick: _cache[2] || (_cache[2] = ($event: any) => (content.value = 1))
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode(" 商品明细 ")
          ])),
          _: 1,
          __: [14]
        }, 8, ["color", "text-color"]),
        _cache[16] || (_cache[16] = _createTextVNode("    ")),
        _createVNode(_component_van_tag, {
          plain: "",
          size: "medium",
          color: content.value === 2 ? _unref(h5Config).themeColor : '',
          "text-color": content.value === 2 ? _unref(h5Config).themeColor : '',
          onClick: _cache[3] || (_cache[3] = ($event: any) => (content.value = 2))
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode(" 商品类别 ")
          ])),
          _: 1,
          __: [15]
        }, 8, ["color", "text-color"])
      ]),
      _: 1
    }),
    _createVNode(_component_van_field, {
      modelValue: title.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((title).value = $event)),
      name: "title",
      label: "抬头",
      placeholder: "请输入抬头"
    }, null, 8, ["modelValue"]),
    (invoiceType.value === 2)
      ? (_openBlock(), _createBlock(_component_van_field, {
          key: 0,
          modelValue: taxNo.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((taxNo).value = $event)),
          name: "taxNo",
          label: "税号",
          placeholder: "请输入税号"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (invoiceType.value === 2)
      ? (_openBlock(), _createBlock(_component_van_field, {
          key: 1,
          modelValue: bankName.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((bankName).value = $event)),
          name: "bankName",
          label: "开户银行",
          placeholder: "请输入开户银行"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (invoiceType.value === 2)
      ? (_openBlock(), _createBlock(_component_van_field, {
          key: 2,
          modelValue: bankAccount.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((bankAccount).value = $event)),
          name: "bankAccount",
          label: "银行账户",
          placeholder: "请输入银行账户"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (invoiceType.value === 2)
      ? (_openBlock(), _createBlock(_component_van_field, {
          key: 3,
          modelValue: companyAddress.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((companyAddress).value = $event)),
          name: "companyAddress",
          label: "单位地址",
          placeholder: "请输入单位地址"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (invoiceType.value === 2)
      ? (_openBlock(), _createBlock(_component_van_field, {
          key: 4,
          modelValue: companyPhone.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((companyPhone).value = $event)),
          type: "tel",
          name: "companyPhone",
          label: "单位电话",
          placeholder: "请输入单位电话"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_field, {
      modelValue: emailAddress.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((emailAddress).value = $event)),
      name: "emailAddress",
      label: "邮箱",
      placeholder: "请输入邮箱"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-gray-600" }, "开票金额:", -1)),
            _createElementVNode("span", _hoisted_6, "¥" + _toDisplayString(orderModel.value.totalAmount), 1)
          ])
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "payment-remark" }, "仅支持在线开增值税电子普通发票", -1))
      ]),
      _createElementVNode("button", {
        class: "ios-button",
        onClick: submitInvoice
      }, " 提交 ")
    ])
  ]))
}
}

})